// src/pages/CourseTime/components/slides/layouts/DefaultFallbackSlide.comp.jsx
import React from 'react';
import * as S from '../../../styles';
import { useSlideContentRenderer } from '../../../hooks/useSlideContentRenderer';

// Handle any unknown layout type
const DefaultFallbackSlide = ({ slide, renderSpokenText, skipTitleSpeech }) => {
  const { renderContent } = useSlideContentRenderer({ renderSpokenText, skipTitleSpeech });

  return (
    <div>
      {typeof slide.SlideContent === 'string' ? (
          <S.SlideDescription>{renderContent('content_0', slide.SlideContent)}</S.SlideDescription>
      ) : Array.isArray(slide.SlideContent) ? (
        <S.SlidePoints>
          {slide.SlideContent.map((point, idx) => (
            <S.SlidePoint key={idx}>
              {typeof point === 'string' ? (
                  <S.PointText>{renderContent(`content_${idx}`, point)}</S.PointText>
              ) : (
                <>
                  {point.PointTitle && <S.PointTitle>{renderContent(`content_${idx}_title`, point.PointTitle)}</S.PointTitle>}
                  {point.PointText  && <S.PointText>{renderContent(`content_${idx}_text`,  point.PointText)}</S.PointText>}
                </>
              )}
            </S.SlidePoint>
          ))}
        </S.SlidePoints>
      ) : (
        <p>No content available for this slide.</p>
      )}
      {slide.Images && slide.Images.length > 0 && (
        <S.SlideImages>
          {slide.Images.map((image, idx) => (
            <S.SlideImage
              key={idx}
              src={typeof image === 'string' ? image : image.url || ''}
              alt={`Slide image ${idx + 1}`}
            />
          ))}
        </S.SlideImages>
      )}
    </div>
  );
};

export default DefaultFallbackSlide;
